module.exports = __webpack_public_path__ + "media/images/photo-upload-bg-e9153ab703053eb22e70a31b38824039.png";